export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-ar-AE.f341ec74.xlsx";